import { IToastIcon } from '@monofe/ui-workspace/common/Toast';

export type ToastType = 'success' | 'error' | 'warn' | 'info';

const MAP_TOAST_TYPE_ICON: Record<ToastType, IToastIcon> = {
    error: IToastIcon.Error,
    warn: IToastIcon.Warning,
    info: IToastIcon.Information,
    success: IToastIcon.Success,
};

export const TypeToIcon = (type: ToastType | undefined): IToastIcon =>
    MAP_TOAST_TYPE_ICON[type ?? 'error'];
